export var ActivityType;
(function (ActivityType) {
    ActivityType["LIFT"] = "lift";
    ActivityType["CARDIO"] = "cardio";
    ActivityType["OTHER"] = "other";
    ActivityType["BENCHMARK"] = "benchmark";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=activityTemplates.js.map